export const TIME = {
    NAVIGATE_DEBOUNCE: 500,
};
